import { GlobalAxios } from "../axios/axios-config";

const ACCESS_CONTROL_PACIENT_SEND_RESTART_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/AccessControlPacientSend/RestartAccessControlPacientSend";

export const restartAccessControlPacientSend = ({
  identifier,
}: {
  identifier: number;
}) => {
  return GlobalAxios.put(ACCESS_CONTROL_PACIENT_SEND_RESTART_ROUTE, {
    identifier,
  });
};
